export { default } from './es/icons/TopFilled';